import { createQueryKeys } from '@lukemorales/query-key-factory';
import { TagService } from '../services';
export const tagQueries = createQueryKeys('tags', {
    getAll: {
        queryKey: null,
        queryFn: TagService.getTags
    }
});
